module.exports = __webpack_public_path__ + "img/logo.e1f74357.png";